/**
 * Generated by Kubb (https://kubb.dev/).
 * Do not edit manually.
 */

import { z } from 'zod';

export const changePasswordRequestSchema = z.object({
  oldPassword: z.coerce.string().min(0).max(200),
  newPassword: z.coerce.string().min(8).max(200),
  newPasswordRepeat: z.coerce.string().min(8).max(200),
});
